import { Component, OnInit } from '@angular/core';
import { geom } from 'openlayers';
import { FeatureComponent } from './feature.component';

@Component({
  selector: 'aol-geometry-linestring',
  template: `<ng-content></ng-content>`
})
export class GeometryLinestringComponent implements OnInit {
  public componentType: string = 'geometry-linestring';
  public instance: geom.LineString;

  constructor(private host: FeatureComponent) {}

  ngOnInit() {
    this.instance = new geom.LineString([]);
    this.host.instance.setGeometry(this.instance);
  }
}

@Component({
  selector: 'aol-geometry-point',
  template: `<ng-content></ng-content>`
})
export class GeometryPointComponent implements OnInit {
  public componentType: string = 'geometry-point';
  public instance: geom.Point;

  constructor(private host: FeatureComponent) {}

  ngOnInit() {
    this.instance = new geom.Point([0, 0]); // defaulting coordinates to [0,0]. To be overridden in child component.
    this.host.instance.setGeometry(this.instance);
  }
}

@Component({
  selector: 'aol-geometry-polygon',
  template: `<ng-content></ng-content>`
})
export class GeometryPolygonComponent implements OnInit {
  public componentType: string = 'geometry-polygon';
  public instance: geom.Polygon;

  constructor(private host: FeatureComponent) {}

  ngOnInit() {
    this.instance = new geom.Polygon([
      [
        [0, 0],
        [1, 0],
        [1, 1]
      ]
    ]);
    this.host.instance.setGeometry(this.instance);
  }
}
